import { useAbstractDelete } from '@/module/Author/Abstract';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface AbstractDeleteButtonProps {
  abstractId: Id;
}

export function AbstractDeleteButton({ abstractId }: AbstractDeleteButtonProps) {
  const mutation = useAbstractDelete(abstractId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
